
/**
 * Get first character.
 */

function getFirstCharacter(value: string): string {
  const codePoint = value.codePointAt(0);

  if (codePoint === undefined) {
    return '';
  }

  return String.fromCodePoint(codePoint);
}

/**
 * Export `getAcronym`.
 */

export function getAcronym(name: string | null | undefined): string | null {
  if (!name) {
    return null;
  }

  return name.toUpperCase().split(' ').map(getFirstCharacter).join('').substring(0, 2);
}
